import styled from 'styled-components'

export const HeaderContainer = styled.div`
    background-color: #fff;
    padding: 20px;
    border-radius: 5px;
    box-sizing: border-box;
    display: grid;
    grid-template-columns: 1fr 1fr;
    overflow: hidden;
`;